import LDClient from "launchdarkly-js-client-sdk"

let client
const getClient = (company) => {
  const context = {
    kind: 'company',
    key: `company_${company.id}`
  }

  if (!client) {
    client = LDClient.initialize(process.env.LAUNCHDARKLY_CLIENT_ID, context)
  }

  return client
}

const LdFeatures = {
  install(Vue, opts = {}) {
    Vue.prototype.$ldFeatures = {
      getClient,
      enabledForCompany: (feature, company) => {
        if (!company) return

        return getClient(company).variation(feature, false)
      },
    }
  },
}

export default LdFeatures
